<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center pt-4">
      <div class="col-md-9 ps-5 pt-2 pb-4">
        <h2 class="col pb-2 title">
          {{ "TEAM" | translate }}
        </h2>
        @if (isActive("settings/team/members")) {
        <h6 class="col subtitle">{{ "TEAMMEMBERS_SUBTITLE" | translate }}</h6>
        }@else if(isActive("settings/team/roles-permissions")){
          <h6 class="col subtitle">{{ "ROLESPERMISSIONS_SUBTITLE" | translate }}</h6>
        }
      </div>
      @if (isActive("settings/team/members")) {
        <div class="col-md-3 d-flex justify-content-end gap-3 pe-5 text-nowrap">
          @if (
            authService.isAuthorized([
              PermissionsEnum.Settings_team_member_bulk_upload,
            ])
          ) {
            <button
              class="col-auto button-add-device justify-content-center"
              [routerLink]="['/upload/user']"
            >
              {{ "BULK_IMPORT" | translate }}
            </button>
          }
          @if (
            authService.isAuthorized([
              PermissionsEnum.Settings_team_member_modify,
            ])
          ) {
            <button
              class="col-auto button-add-device justify-content-center text-nowrap"
              [routerLink]="['../team/team-setup']"
            >
              {{ "SETTINGS_TEAMSETUP" | translate }}
            </button>
          }
        </div>
      } @else if (isActive("settings/team/roles-permissions")) {
        @if (
          authService.isAuthorized([PermissionsEnum.Settings_team_role_view])
        ) {
          <div class="col-md-3 d-flex justify-content-end pe-5 text-nowrap">
            <button
              class="col-auto button-add-device justify-content-center"
              [routerLink]="['../team/role-setup']"
            >
              {{ "ADDROLE" | translate }}
            </button>
          </div>
        }
      }
    </div>
  </div>
  <div class="row g-0 m-0 pt-1">
    <div class="tabs">
      <ul>
        <li
          class="pb-4"
          (click)="navigate('settings/team/members')"
          [class.active]="isActive('settings/team/members')"
        >
          {{ "MEMBERS" | translate }}
        </li>
        <li
          class="pb-4"
          (click)="navigate('settings/team/roles-permissions')"
          [class.active]="isActive('settings/team/roles-permissions')"
        >
          {{ "ROLESPERMISSIONS" | translate }}
        </li>
      </ul>
    </div>
  </div>
  <div class="row g-0 m-0 pt-2">
    <router-outlet></router-outlet>
  </div>
</div>
